module.exports = __webpack_public_path__ + "static/media/golden-cup-icon.b32550e5.svg";